export const LPQV_GATEWAYS = [];
